import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const QR_SCRIPT_ID = 'qrcodejs-cdn-script';
const QR_SCRIPT_SRC = 'https://cdn.jsdelivr.net/npm/qrcodejs@1.0.0/qrcode.min.js';

const SellerWaitingQr = () => {
  const [loading, setLoading] = useState(true);
  const [shopId, setShopId] = useState(0);
  const [shopName, setShopName] = useState('');
  const [url, setUrl] = useState('');
  const qrRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get('/api/seller/waiting/qr-data', {
          withCredentials: true,
        });

        if (!res.data || res.data.ok !== true) {
          alert((res.data && res.data.msg) || '불러오기 실패');
          window.location.href = '/seller/manage';
          return;
        }

        setShopId(res.data.shop_id || 0);
        setShopName(res.data.shop_name || '매장');
        setUrl(res.data.url || '');
      } catch (err) {
        console.error(err);
        alert('불러오기 실패');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!url || !qrRef.current) return;

    const renderQr = () => {
      if (!window.QRCode || !qrRef.current) return;

      qrRef.current.innerHTML = '';

      new window.QRCode(qrRef.current, {
        text: url,
        width: 220,
        height: 220,
      });
    };

    const existing = document.getElementById(QR_SCRIPT_ID);

    if (existing) {
      if (window.QRCode) {
        renderQr();
      } else {
        existing.addEventListener('load', renderQr, { once: true });
      }
      return;
    }

    const script = document.createElement('script');
    script.id = QR_SCRIPT_ID;
    script.src = QR_SCRIPT_SRC;
    script.async = true;
    script.onload = renderQr;
    document.body.appendChild(script);

    return () => {
      script.onload = null;
    };
  }, [url]);

  const copyUrl = async () => {
    const t = (url || '').trim();
    try {
      await navigator.clipboard.writeText(t);
      alert('URL 복사 완료');
    } catch (e) {
      window.prompt('복사 실패: 아래 URL을 복사하세요', t);
    }
  };

  if (loading) {
    return (
      <div className="container py-3" style={{ maxWidth: '720px' }}>
        불러오는 중...
      </div>
    );
  }

  return (
    <>
      <style>{`
        .card-q{border:1px solid #e9ecef;border-radius:14px}
        .qr-wrap{
          width:240px;
          height:240px;
          display:flex;
          align-items:center;
          justify-content:center;
          border:1px dashed #ced4da;
          border-radius:12px;
          background:#fff
        }
        @media print {
          .no-print{display:none !important;}
          .qr-wrap{border:0 !important;}
          body{background:#fff !important;}
          .card-q{border:0 !important;}
        }
      `}</style>

      <div className="container py-3" style={{ maxWidth: '720px' }}>
        <div className="d-flex justify-content-between align-items-center mb-3 no-print">
          <div>
            <h5 className="m-0">웨이팅 QR 생성</h5>
            <div className="text-muted small">
              {shopName} (shop_id={shopId})
            </div>
          </div>

          <div className="d-flex gap-2">
            <button className="btn btn-dark btn-sm" onClick={() => window.print()}>
              인쇄
            </button>
            <button className="btn btn-outline-secondary btn-sm" onClick={copyUrl}>
              URL 복사
            </button>
            <a className="btn btn-outline-secondary btn-sm" href="/seller/waiting/manage">
              웨이팅 관리
            </a>
          </div>
        </div>

        <div className="card-q p-3">
          <div className="d-flex gap-3 align-items-center flex-wrap">
            <div className="qr-wrap">
              <div ref={qrRef} id="qr" data-url={url}></div>
            </div>

            <div className="flex-grow-1" style={{ minWidth: '260px' }}>
              <div className="fw-bold" style={{ fontSize: '20px', lineHeight: 1.1 }}>
                웨이팅 접수 QR
              </div>
              <div className="text-muted small mt-1">
                손님이 QR 스캔 → 접수 → 상태확인
              </div>

              <div className="small mt-3 text-muted">접수 주소</div>
              <div className="small mt-1" style={{ wordBreak: 'break-all' }}>
                <span id="regUrl">{url}</span>
              </div>

              <div className="mt-3">
                <div className="text-muted small">
                  * QR을 찍고 이름/전화/인원 입력
                  <br />
                  * 호출되면 “지금 입장해주세요!” 표시
                  <br />
                  * 취소는 상태 화면에서 가능
                </div>
              </div>

              <div className="no-print mt-3">
                <a
                  className="btn btn-outline-dark btn-sm"
                  target="_blank"
                  rel="noreferrer"
                  href={url}
                >
                  열기
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SellerWaitingQr;